import React from 'react';
import { FormState, Form as FormStateForm } from 'react-formstate';
import classNames from 'classnames';
import WiredInput from '../components/WiredInput';
import { focusOnFirstInvalid, populateFormErrors } from '../../utils/validation';
import ValidationMessage from '../components/ValidationMessage';
import LanguageSwitcher from '../components/LanguageSwitcher';
import T from '../components/T';
import FacebookLogin from '../facebook/LoginButton';
import FacebookProvider from '../facebook/FacebookProvider';
import forceRerenderParent from '../components/forceRerenderParent';

class Form extends React.Component {
  formState = FormState.create(this);
  state = {};

  onInputChange = ({ target: { name, value } }) => {
    const context = this.formState.createUnitOfWork(); // this is so java
    context.set(name, value).validate();
    context.updateFormState();
  };

  onSubmit = (e) => {
    const { onSubmit } = this.props;
    e.preventDefault();

    const model = this.formState.createUnitOfWork().createModel();
    if (model) {
      onSubmit(e, model);
    } else {
      focusOnFirstInvalid(this.formState, this);
    }
  };

  render() {
    const { formDisabled, onCancel, onForgot, langSwitcher, displaySocialLogin } = this.props;
    const errors = populateFormErrors(this.formState);

    return (
      <section className="login">
        <div className="c-floating">
          {(onCancel || langSwitcher) &&
          <div className="c-floating__head">
            {onCancel
              ? <span className="u-link text-icon" onClick={onCancel}>
                  <i className="icon-arrow-back text-icon__icon" />
                  <span className="text-icon__text">Naspäť</span>
                </span>
              : null
            }
            {langSwitcher
              ? <LanguageSwitcher />
              : null
            }
          </div>
          }
          <FormStateForm formState={this.formState} className="c-floating__body c-inactive-bg__stop" onSubmit={this.onSubmit}>
            <fieldset disabled={formDisabled}>
              <h1 className="new-campaign__header">
                <T msg="login.form.title" />
              </h1>

              <label className="c-input__wrapper">
                <span className="c-input__label">
                  <T msg="login.form.labels.email" />
                </span>
                <span className={classNames(
                  'c-input__border', 'new-campaign__input-text',
                  { 'c-input__border--error': errors.email }
                )}>
                  <WiredInput
                    name="email"
                    className="c-input"
                    onChange={this.onInputChange}
                    autoFocus
                    validator={v => v
                      .required().msg('login.form.errors.email.required')
                      .email().msg('login.form.errors.email.email')}
                  />
                </span>
                <ValidationMessage msg={errors.email} />
              </label>

              <label className="c-input__wrapper">
                <span className="c-input__label">
                  <T msg="login.form.labels.password" />
                </span>
                <span className={classNames(
                  'c-input__border', 'new-campaign__input-text',
                  { 'c-input__border--error': errors.password }
                )}>
                  <WiredInput
                    name="password"
                    className="c-input"
                    type="password"
                    validator={v => v
                      .required().msg('login.form.errors.password.required')}
                    onChange={this.onInputChange}
                  />
                </span>
                <ValidationMessage msg={errors.password} />
              </label>

              <button type="submit" className="c-button c-button--primary new-campaign__button">
                <span className="c-button__content">
                  <span className="text-icon">
                    <span className="text-icon__text">
                      <T msg="login.form.actions.login" />
                    </span>
                    <i className="icon-arrow-forward text-icon__icon" />
                  </span>
                </span>
              </button>

              <div className="expander l-no-desktop l-no-tablet" />

              {displaySocialLogin &&
              <div className="new-campaign__social">
                <div>
                  <FacebookProvider>
                    <FacebookLogin redirectTo={window.location.href} from="login" />
                  </FacebookProvider>
                </div>
              </div>
              }
            </fieldset>

            {onForgot &&
            <a href="/p2p/reset-hesla/" className="u-underline">
              <T msg="login.form.actions.forgotPassword" />
            </a>
            }
          </FormStateForm>
        </div>
      </section>
    );
  }
}

export default forceRerenderParent(Form);



// WEBPACK FOOTER //
// ./app/Assets/js/features/login/Form.js